var render = function render(){var _vm=this,_c=_vm._self._c;return _c('le-select-remote-search',{attrs:{"label":_vm.label,"options":_vm.myOptions,"placeholder":_vm.placeholder,"notnull":_vm.notnull,"large":_vm.large},model:{value:(_vm.myValue),callback:function ($$v) {_vm.myValue=$$v},expression:"myValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }